<template>
  <div>
    <div class="bg-secondary-3 rounded p-2">
      <board :details="boardInfo" />
      <div class="row mt-3 mx-0 mb-2">
        <div class="col col-sm col-12">
          <div>
            <div class="color-secondary-6 font-14">Tipo de Servicio:</div>
            <div class="color-secondary-29">
              {{
                (item.disciplineTypeName ?? item.disciplineType?.name) || '-'
              }}
            </div>
          </div>
        </div>
        <div class="col col-sm col-12">
          <div>
            <div class="color-secondary-6 font-14">Modalidad:</div>
            <div class="color-secondary-29">{{ item.modalityName || '-' }}</div>
          </div>
        </div>
        <div class="col col-sm col-12">
          <div>
            <div class="color-secondary-6 font-14">Frecuencia:</div>
            <div class="color-secondary-29">
              {{ item.frequencyName || '-' }}
            </div>
          </div>
        </div>
        <div class="col col-sm col-12">
          <div>
            <div class="color-secondary-6 font-14">Duración:</div>
            <div class="color-secondary-29">{{ item.durationName || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Board from 'Board';
export default {
  name: 'StudentInfo',
  components: {
    Board,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    boardInfo() {
      const itemData = this.item || {};
      return [
        [
          {
            label: 'SIE:',
            data: itemData.studentSieId || '-',
            icon: 'fas fa-address-book',
          },
          {
            label: 'Estudiante:',
            data: itemData.studentName || '-',
            icon: 'fas fa-address-book',
          },
          {
            label: 'Edad',
            data: `${itemData.studentAge} años` || '-',
            icon: 'fas fa-calendar-edit',
          },
          {
            label: 'Impedimento',
            data: itemData.studentImpedimentName || '-',
            icon: 'fas fa-ballot-check',
          },
        ],
      ];
    },
  },
};
</script>
